addEventListener("direct-upload:initialize", event => {
  const { target, detail } = event
  const { id, file } = detail
  target.insertAdjacentHTML("beforebegin", `
    <div id="direct-upload-${id}" class="direct-upload direct-upload--pending text-sm px-3 py-2 rounded-md border border-gray-300">
      <div id="direct-upload-progress-${id}" class="direct-upload__progress absolute top-0 left-0 bottom-0 bg-indigo-600 bg-opacity-25 rounded-md" style="width: 0%"></div>
      <span class="direct-upload__filename"></span>
    </div>
  `)
  target.previousElementSibling.querySelector(`.direct-upload__filename`).textContent = file.name
  target.style.display = 'none'
})

addEventListener("direct-upload:start", event => {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.remove("direct-upload--pending")
})

addEventListener("direct-upload:progress", event => {
  const { id, progress } = event.detail
  const progressElement = document.getElementById(`direct-upload-progress-${id}`)
  progressElement.style.width = `${progress}%`
})

addEventListener("direct-upload:error", event => {
  event.preventDefault()
  const { id, error } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--error", "border-red-400", "text-red-700")
  element.setAttribute("title", error)

  element.parentElement.insertAdjacentHTML("afterend",`
    <p class='mt-2 text-sm text-red-600'>${error}</p>
  `)
  element.insertAdjacentHTML("afterend",`
    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
      <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
      </svg>
    </div>
  `)
})

addEventListener("direct-upload:end", event => {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--complete")
  if (!element.classList.contains('direct-upload--error')) {
    const progressElement = document.getElementById(`direct-upload-progress-${id}`)
    progressElement.classList.remove('bg-indigo-600')
    progressElement.classList.add('bg-green-600')
  }
})